import { Component, OnInit, Input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Client } from '../../core/models';
import { RankingService, ProfileService } from 'core/services';

@Component({
  selector: 'lms-ranking-list',
  templateUrl: './ranking-list.component.html'
})
export class RankingListComponent implements OnInit {
  public clientId: string;
  @Input() client: Client;
  public fieldNames: any = ['rank', 'name', 'score'];

  public listId = 'RANKING_LIST';
  public listOptions: any = {};
  public ranking: any = [];
  constructor(
    public route: ActivatedRoute,
    public activatedRoute: ActivatedRoute,
    public rankingService: RankingService,
    public profileService: ProfileService
  ) {}
  ngOnInit() {
    this.profileService.getLoggedUser$().subscribe((loggedUser) => {
      let client: any;
      if (loggedUser.roleOptions.scope === 'client') {
        client = loggedUser.clients.find((cli) => cli.clientId === loggedUser.selectedClientId);
      }
      this.clientId = this.client ? this.client.id : client ? client.clientId : null;
      this.listOptions = Object.assign({}, this.listOptions, { clientId: this.clientId });
    });
  }
  setCollection(collection) {
    this.ranking = collection;
  }
}
